import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-808dcb18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OkFile__wrap" }
const _hoisted_2 = {
  key: 0,
  class: "OkFile__name"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "OkInput__required" }, "*", -1))
const _hoisted_4 = ["disabled", "accept", "multiple"]
const _hoisted_5 = {
  key: 0,
  class: "fas fa-paperclip mr-2"
}
const _hoisted_6 = {
  key: 1,
  class: "OkFile__error"
}
const _hoisted_7 = {
  key: 2,
  class: "OkFile__list"
}
const _hoisted_8 = { class: "item__name" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 1,
  class: "fas fa-spinner ml-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (Boolean(_ctx.name))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.required)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.name) + " ", 1),
                _hoisted_3
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.name), 1)
              ], 64))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("label", {
      class: _normalizeClass(["OkFile", { 'OkFile--notempty': _ctx.value.length > 0, invalid: _ctx.isInvalid }]),
      tabindex: "0"
    }, [
      _createElementVNode("input", {
        type: "file",
        hidden: "",
        disabled: _ctx.disabled,
        accept: _ctx.accept,
        multiple: _ctx.multiple,
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitUpdate && _ctx.emitUpdate(...args)))
      }, null, 40, _hoisted_4),
      _createElementVNode("p", {
        class: _normalizeClass(["OkFile__placeholder", { selected: _ctx.value.length > 0 }])
      }, [
        (_ctx.value.length < 0)
          ? (_openBlock(), _createElementBlock("i", _hoisted_5))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.computedPlaceholder), 1)
      ], 2),
      (!_ctx.disabled && _ctx.value.length > 0)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: "OkFile__reset fas fa-times",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetFiles && _ctx.resetFiles(...args)), ["prevent"]))
          }))
        : _createCommentVNode("", true)
    ], 2),
    (Boolean(_ctx.validationErrors.length))
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.getValidationMessage(_ctx.validationErrors)), 1))
      : _createCommentVNode("", true),
    (_ctx.value.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.value, (file, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "list__item",
              key: file
            }, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(file.name), 1),
              (!_ctx.disabled && !_ctx.loading)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: "item__remove fas fa-times ml-3",
                    onClick: ($event: any) => (_ctx.removeFile(i))
                  }, null, 8, _hoisted_9))
                : _createCommentVNode("", true),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}